var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnbGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 2500 2500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M764.488 1050.52L1249.99 565.037L1735.74 1050.77L2018.24 768.275L1249.99 0L482 768.025L764.488 1050.52ZM0.00756836 1249.96L282.516 967.452L565.006 1249.94L282.5 1532.45L0.00756836 1249.96ZM764.488 1449.47L1249.99 1934.96L1735.73 1449.24L2018.38 1731.59L2018.24 1731.74L1249.99 2500L481.975 1732L481.575 1731.6L764.488 1449.47ZM1935.02 1250.12L2217.53 967.609L2500.02 1250.1L2217.51 1532.61L1935.02 1250.12Z",
    fill: "#878A93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1536.52 1249.85H1536.65L1249.99 963.188L1038.14 1175.04H1038.13L1013.79 1199.39L963.588 1249.6L963.188 1249.99L963.588 1250.4L1249.99 1536.81L1536.65 1250.15L1536.79 1249.99L1536.52 1249.85Z",
    fill: "#878A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbGrey);
export default __webpack_public_path__ + "static/media/bnb-grey.9191a147932070e18c26f75b4516df46.svg";
export { ForwardRef as ReactComponent };